import React from 'react';

const ErrorMessage = ({ message }) => (
  <article className="message is-danger">
    <div className="message-body">{message}</div>
  </article>
);

export default ErrorMessage;
